import { render, staticRenderFns } from "./StepFaixas.vue?vue&type=template&id=4577373c&scoped=true"
import script from "./StepFaixas.vue?vue&type=script&lang=js"
export * from "./StepFaixas.vue?vue&type=script&lang=js"
import style0 from "./StepFaixas.vue?vue&type=style&index=0&id=4577373c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4577373c",
  null
  
)

export default component.exports